var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-chat"},[_c('deep-chat',{ref:"chat",staticClass:"agent-chat__window"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }